import { Button } from '#/components/Button/Button';
import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';

import { Card } from './Card';
import { Container } from './Container';
import { JobDescription_Box_1 } from './JobDescription.styled';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  job: Record<string, any>;
  title: string;
  onReset: () => void;
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  siblings: any;
  setRelatedJobsShowing: (arg0: boolean) => void;
};

export function JobDescription({
  job,
  title,
  siblings,
  setRelatedJobsShowing,
  onReset,
}: Props) {
  const { i18n } = useI18n();

  return (
    <Container>
      <div style={{ paddingBlock: '8px' }}>
        <Card content={{ ...job, name: title }} />

        <JobDescription_Box_1>
          <Button
            type="button"
            variant="tertiary"
            noPadding
            onClick={() => {
              if (siblings) {
                setRelatedJobsShowing(true);
              } else {
                onReset();
              }
            }}
            qaId="title-not-match"
          >
            {i18n("This doesn't match my job")}
          </Button>

          <BodySmall
            styleAs="bodySmall"
            style={{ color: colors.lightContentGrey, marginTop: '8px' }}
          >
            {i18n(`Job descriptions serve as a guide and may not be specific to your role.
              Required experience and responsibilities will vary depending on your individual role.`)}
          </BodySmall>
        </JobDescription_Box_1>
      </div>
    </Container>
  );
}
